import type { CompanyMonitoring } from "~/types"
import type { RealtimePostgresChangesPayload } from '@supabase/supabase-js'
export async function fetchCompetitors(companyId: string) {
  console.log("Fetching competitors for company:", companyId)
  const { $supabase } = useNuxtApp()

  const companyCompetitors = useCompanyCompetitors()

  companyCompetitors.value.isLoading = true
  companyCompetitors.value.error = null

  try {
    // Then fetch competitors using the internal ID
    console.log("Fetching competitors for internal ID:", companyId)
    const { data, error } = await $supabase
      .from('companies_monitoring')
      .select('*')
      .eq('company_id', companyId)

    if (error) {
      console.error("Error fetching competitors:", error)
      throw error
    }

    console.log("Fetched competitors:", data)
    companyCompetitors.value.competitors = data
  } catch (err) {
    console.error('Error in fetchCompetitors:', err)
    companyCompetitors.value.error = 'Failed to load competitor data'
  } finally {
    companyCompetitors.value.isLoading = false
  }
}

export async function handleRealtimeCompetitorUpdate(payload: RealtimePostgresChangesPayload<CompanyMonitoring>) {
  console.log("Realtime update received:", payload)

  const companyCompetitors = useCompanyCompetitors()

  companyCompetitors.value.isLoading = true
  companyCompetitors.value.error = null

  const { eventType, new: newRecord, old: oldRecord } = payload


  switch (eventType) {
    case 'INSERT':
      if (newRecord) {
        companyCompetitors.value.competitors.push(newRecord)
      }
      break

    case 'UPDATE':
      if (newRecord) {
        const index = companyCompetitors.value.competitors.findIndex(c => c.id === newRecord.id)
        if (index !== -1) {
          companyCompetitors.value.competitors[index] = newRecord
        } else {
          companyCompetitors.value.competitors.push(newRecord)
        }
      }
      console.log("Updated competitors:", companyCompetitors.value.competitors)
      break

    case 'DELETE':
      if (oldRecord) {
        const index = companyCompetitors.value.competitors.findIndex(c => c.id === oldRecord.id)
        if (index !== -1) {
          companyCompetitors.value.competitors.splice(index, 1)
        }
      }
      break
  }

  companyCompetitors.value.isLoading = false

  
} 